(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["page-our-story-about-us"]) return;
  try {
    
    $(document).ready(function(){
        $('.btn-our-story-about-us.show-more').on('click', function(){
            $(this).closest('ul').find('.hidden-item').addClass('show-item').removeClass('hidden-item')
            $(this).addClass('hidden-item')
        })
        $('.btn-our-story-about-us.show-less').on('click', function(){
            $(this).closest('ul').find('.show-item').addClass('hidden-item').removeClass('show-item')
            $(this).addClass('hidden-item')
            $(this).closest('ul').find('.show-more').removeClass('hidden-item')
        })
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-our-story-bbb-news"]) return;
  try {
    
    $(document).ready(function(){
        $('.btn-our-story-bbb-news.show-more').on('click', function(){
            $(this).closest('ul').find('.hidden-item').addClass('show-item').removeClass('hidden-item')
            $(this).addClass('hidden-item')
        })
        $('.btn-our-story-bbb-news.show-less').on('click', function(){
            $(this).closest('ul').find('.show-item').addClass('hidden-item').removeClass('show-item')
            $(this).addClass('hidden-item')
            $(this).closest('ul').find('.show-more').removeClass('hidden-item')
        })
    })

  } catch(e) { console.error(e); }
})();

})();
